import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, NestedArray } from '@hvlng/framework-bff/core';
import { AuthorizedEmployeeCardHrmTypeModel } from './authorized-employee-card-hrm-type-model';

@JsonObject('KovanHrAuthorizedEmployeeCardModel')
export class AuthorizedEmployeeCardModel {
    @EmptyControl()
    @JsonProperty('employeeCardCode', String, true)
    employeeCardCode: string = null;

    @EmptyControl()
    @JsonProperty('canEdit', Boolean, true)
    canEdit: boolean = null;

    @EmptyControl()
    @JsonProperty('canRead', Boolean, true)
    canRead: boolean = null;

    @NestedArray(AuthorizedEmployeeCardHrmTypeModel)
    @JsonProperty('hrmTypeLimitations', [AuthorizedEmployeeCardHrmTypeModel], true)
    hrmTypeLimitations: Array<AuthorizedEmployeeCardHrmTypeModel> = new Array<AuthorizedEmployeeCardHrmTypeModel>();

    get canView(): boolean {
        return this.canRead;
    }
}
